import React from 'react';
import { Typography } from '../../../../designSystem/components/Typography';

type Wrap = 'left' | 'right' | 'none';

interface InformationRowProps {
  title: React.ReactNode;
  value: React.ReactNode;
  wrap?: Wrap;
}

export const InformationRow = ({
  title,
  value,
  wrap = 'none',
}: InformationRowProps) => {
  return (
    <tr className="last:border-b-0">
      <td
        className={[
          'bg-gray-50 px-4 py-3 align-top',
          'text-sm font-medium text-gray-700',
          'border-b border-gray-200',
          wrap === 'left' && 'whitespace-nowrap',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <Typography variant="body">{title}</Typography>
      </td>

      <td
        className={[
          'px-4 py-3 align-top',
          'text-sm text-gray-800',
          'border-b border-gray-200',
          wrap === 'right' && 'whitespace-nowrap',
        ]
          .filter(Boolean)
          .join(' ')}
      >
        <Typography variant="body">{value}</Typography>
      </td>
    </tr>
  );
};